import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Icon } from '@user-portal/wikr-components';

import { SUBSCRIPTION_LABEL_STATES } from '../constants';

import SubscriptionStatusLabel from './subComponents/SubscriptionLabel';
import SubscriptionCardHeader from './subComponents/SubscriptionCardHeader';
import PriceRow from './subComponents/PriceRow';
import PeriodRow from './subComponents/PeriodRow';
import { IncludedInYourPlanRow } from './subComponents/IncludedInYourPlanRow';
import BillingPeriod from './subComponents/BillingPeriod';
import AdditionalStatusInfo from './subComponents/AdditionalStatusInfo';

import * as S from './styled';

import { IExpiresSoonSubscription } from '../types';

import SubscriptionCardWrapper from './SubscriptionCardWrapper';

const ExpiresSubscription = ({
    tabIcon,
    heading,
    subscriptionPeriod,
    price,
    isTrial,
    isUpgrade,
    isMainSubscription,
    productCode,
    captions,
    onShowReturnOffer,
    isOfferAvailableForSubscription,
    isReturnOfferApplied,
    isOneTimeProduct,
    isPromoCodeUsed,
}: IExpiresSoonSubscription) => {
    const { t } = useTranslation();
    const isReturnOfferNeeded =
        !isReturnOfferApplied && isOfferAvailableForSubscription && !isOneTimeProduct && !isPromoCodeUsed;

    return (
        <SubscriptionCardWrapper>
            <SubscriptionCardHeader
                isMainSubscription={isMainSubscription}
                productCode={productCode}
                Icon={tabIcon}
                heading={heading}
            />

            <SubscriptionStatusLabel state={SUBSCRIPTION_LABEL_STATES.CANCELED} />
            <PeriodRow period={subscriptionPeriod} isTrial={isTrial} />
            <PriceRow price={price} />
            <BillingPeriod period={subscriptionPeriod} />
            {isUpgrade && <IncludedInYourPlanRow isCardRow />}
            <S.Line $mt={16} />
            {(captions?.title || captions?.description) && <AdditionalStatusInfo captions={captions} />}
            {isReturnOfferNeeded && (
                <>
                    <S.Disclaimer>
                        <Icon name="info" color="text-secondary-subdued" size={24} />
                        <S.SubscriptionDisclaimer type="medium-text" color="text-secondary" mb={10}>
                            {t('subscription.management.description')}
                        </S.SubscriptionDisclaimer>
                    </S.Disclaimer>
                    <Button dataLocator="showReturnOfferBtn" onClick={onShowReturnOffer}>
                        {t('subscription.text.showReturnOffer')}
                    </Button>
                </>
            )}
        </SubscriptionCardWrapper>
    );
};

export default ExpiresSubscription;
